import Vue from 'vue'

const state = {
  isRouterAlive: true
}

const mutations = {
  reload: (state) => {
    state.isRouterAlive = false;
    Vue.nextTick(function () {
      state.isRouterAlive = true;
    });
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
